<template>
  <ModalCardDefault :title="title" @close="$emit('close')">
    <ExpansionPanel
      v-model="panel"
      :title="'Lista das Movimentações do Produto'"
      :icon="$icons.box"
      readonly
    >
      <DataTable
        no-search
        :items-per-page="5"
        :items="productVariationStockMovements"
        :headers="headers"
        :loading="loading"
      >
        <template v-slot:item.operation_formatted="{ item }">
          <Chip
            :label="item.operation_formatted"
            small
            :color="colorsOperation[item.operation]"
          />
        </template>
        <template v-slot:item.created_at_formatted="{ item }">
          {{ item.created_at_formatted }}
        </template>
      </DataTable>
    </ExpansionPanel>
  </ModalCardDefault>
</template>

<script>
import ModalCardDefault from '@/components/ModalCardDefault';
import { DataTable, ExpansionPanel, Chip } from '@/components/vuetify';
import { typeStockMovements } from '@/utils/enums';
import { formatDatePT } from '@/utils';

export default {
  name: 'ListProductVariationStockMovements',
  components: {
    DataTable,
    ExpansionPanel,
    ModalCardDefault,
    Chip,
  },
  props: {
    productVariationId: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      panel: [0],
      utils: {
        formatDatePT,
      },
      loading: false,
      productVariationStockMovements: [],
      colorsOperation: {
        [typeStockMovements.INPUT]: 'success',
        [typeStockMovements.OUTPUT]: 'error',
      },
    };
  },
  computed: {
    headers() {
      return [
        { text: 'Descrição', value: 'description' },
        { text: 'Data', value: 'created_at' },
        { text: 'Tipo', value: 'movement_type' },
        { text: 'Saldo Anterior', value: 'previous_balance_product_variation' },
        { text: 'Quantidade', value: 'quantity' },
        { text: 'Saldo Atual', value: 'current_balance_product_variation' },
      ];
    },
  },
  watch: {
    productVariationId: {
      handler() {
        this.getProductVariationStockMovements();
      },
      deep: true,
    },
  },
  methods: {
    getProductVariationStockMovements(pagination) {
      this.loading = !this.loading;
      this.$api.products
        .getProductVariationStockMovementsByProductVariationId(
          this.productVariationId,
          pagination
        )
        .then((res) => {
          this.productVariationStockMovements = res;
        })
        .catch(() => {
          this.$noty.error(
            'Erro ao buscar os movimentos de estoque do Produto.'
          );
        })
        .finally(() => {
          this.loading = !this.loading;
        });
    },
  },
  mounted() {
    this.getProductVariationStockMovements();
  },
};
</script>
